import Clarity from "@microsoft/clarity";
import { useEffect } from "react";

import { CLARITY_PROJECT_ID } from "~/constants/analytics";

export const ClarityScript = () => {
  useEffect(() => {
    if (CLARITY_PROJECT_ID) {
      Clarity.init(CLARITY_PROJECT_ID);
    }
  }, []);

  return null;
};
